export const AFTERlOGIN_CHANGE_PASSWORD_INFO = "AFTERlOGIN_CHANGE_PASSWORD_INFO";
export const AFTERlOGIN_CHANGE_PASSWORD_INFO_SUCCESS = "AFTERlOGIN_CHANGE_PASSWORD_INFO_SUCCESS";
export const AFTERlOGIN_CHANGE_PASSWORD_INFO_ERROR = "AFTERlOGIN_CHANGE_PASSWORD_INFO_ERROR";